"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEditorialCategoryOrPageData = void 0;
var _presentationHttp = require("@ori/presentation-http");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _getEditorialCategoryOrPage = require("./getEditorialCategoryOrPage");
// istanbul ignore file @preserve -- api

/**
 * Function calls fetch functions and returns data needed for editorial landing page.
 */
const getEditorialCategoryOrPageData = async ({
  applicationName,
  atpClusterId,
  language,
  customerTypeId,
  graphQlUrl,
  pageId,
  previewMode,
  staticApiUrl,
  tenant,
  token,
  landingPageId
}) => {
  const staticApiClient = new _staticApiClientReact.ApiClient({
    baseUrl: staticApiUrl,
    language,
    tenant
  });
  const headers = (0, _presentationHttp.getHeaders)({
    sourceAppName: applicationName,
    language,
    tenant,
    token,
    atpClusterId,
    customerTypeId
  });
  const [breadcrumbs, editorialCategoryOrPageData, {
    data: productBoxConfiguration
  }] = await Promise.all([(0, _presentationHttp.getBreadcrumbs)({
    language,
    pageId,
    staticApiClient,
    tenant
  }), (0, _getEditorialCategoryOrPage.getEditorialCategoryOrPage)({
    graphQlUrl,
    headers,
    pageId,
    previewMode,
    landingPageId
  }), (0, _staticApiClientReact.getTenantApplicationsProductboxConfiguration)(staticApiClient, tenant, {
    customerTypeId: customerTypeId ?? undefined
  })]);
  return {
    breadcrumbs,
    editorialCategoryOrPageData,
    productBoxConfiguration
  };
};
exports.getEditorialCategoryOrPageData = getEditorialCategoryOrPageData;
